import React, { useEffect, useState } from "react";
import { Modal } from "antd";
import plusIcon from "../../../assets/images/Svg/plusIcon.svg";
import AddSurgicalHistory from "./AddSurgicalHistory";
import MedicalService from "../../../Services/MedicalService";
import dayjs from "dayjs";
import { FiPlus } from "react-icons/fi";

function SurgicalHistory(props) {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [surgicalHistoryData, setSuricalHistoryData] = useState([]);

  useEffect(() => {
    patientSurgicalHistory();
  }, [props.selectedPatient.patientId]);

  const handleSurgicalClick = () => {
    setIsModalVisible(true);
  };
  const handleCloseModal = () => {
    setIsModalVisible(false);
    patientSurgicalHistory();
  };

  const patientSurgicalHistory = () => {
    let payload = {
      patientId: props.selectedPatient.patientId,
      status: 1,
    };
    MedicalService.PatientSurgicalHistory(payload)
      .then((result) => {
        setSuricalHistoryData(result.data);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  return (
    <div>
      {/* <div className="card h-[300px] m-5 border rounded-lg">
        <div className="header h-[15%] bg-secondaryColor flex items-center justify-between  rounded-lg p-2">
          <h1 className="font-bold text-normal  text-white ">
            Surgical History
          </h1>
          <img
            src={plusIcon}
            onClick={() => handleSurgicalClick()}
            className="h-10 w-10 cursor-pointer"
            alt=""
          />
        </div>
        <div
          className="body h-[70%] overflow-y-auto bg-brand-lightBg p-2"
          id="unquie-scroll"
        >
          {surgicalHistoryData.length > 0
            ? surgicalHistoryData.map((user, i) => (
                <div>
                  <div key={i} className="items-center text-sm mt-3">
                    <div className="font-medium text-black">
                      {" "}
                      Surgical History :{" "}
                      <span className="font-medium text-gray-500">
                        {user.surgicalInfo}
                      </span>
                    </div>
                    <div className="ml-auto text-gray-500 mt-2 font-medium">
                      Onset date :{" "}
                      {dayjs(user.givenDate).format("YYYY-MM-DD")}
                    </div>
                  </div>
                  <hr className="my-4 border-gray-300" />
                </div>
              ))
            : null}
        </div>
        <div className="footer h-[10%]  bg-secondaryColor rounded-md"></div>
      </div> */}
      <div
        className="bg-white rounded-xl border border-gray-200 shadow-sm w-full"
        id="unquie-scroll"
      >
        <div className="flex justify-between items-center p-3">
          <h3 className="text-sm font-bold text-gray-700"> Surgical History</h3>
          <div className="flex items-center gap-2 text-blue-500 font-sans font-medium underline text-xs cursor-pointer">
            <div
              onClick={() => handleSurgicalClick()}
              className="w-6 h-6 rounded-full flex items-center justify-center bg-primaryColor"
            >
              <FiPlus className="text-white w-4 h-4" />
            </div>
            {/* <HiPlusCircle className="text-primaryColor w-7 h-7"/> */}
          </div>
        </div>
        <hr />
                <div className="h-44 p-3 overflow-y-scroll flex flex-col gap-3 scrollWidth">
        {surgicalHistoryData.length > 0 ? (
          surgicalHistoryData.map((user, i) => (
              <div className="relative">
                <div className="overflow-y-scroll pr-2 scrollWidth flex flex-col gap-2">
                  <div className="bg-[#F6F9FF] border border-[#8DADF6] border-l-4 rounded-lg p-3 text-xs text-gray-700 flex flex-col gap-2">
                    <p>
                      <strong>Surgical History :</strong> {user.surgicalInfo}
                    </p>
                    <p>
                      Onset Date : {dayjs(user.givenDate).format("YYYY-MM-DD")}
                    </p>
                  </div>
                </div>
              </div>
          ))
        ) : (
          <div></div>
        )}
        </div>
      </div>

      {isModalVisible && (
        <Modal
          title={
            <span className="text-base font-bold font-sans">
              Add Surgical History
            </span>
          }
          visible={isModalVisible}
          onOk={() => handleCloseModal()}
          centered={true}
          footer={null}
          onCancel={() => handleCloseModal()}
          okText="Submit"
          cancelText="Cancel"
          width={500}
          maskClosable={false}
        >
          <AddSurgicalHistory
            selectedPatient={props.selectedPatient}
            onClose={() => handleCloseModal()}
          />
        </Modal>
      )}
    </div>
  );
}

export default SurgicalHistory;
